<div class="standardpanel">
  <!-- <div class="titleblock">
    <h3 class="title1level">Petitum</h3>
  </div> -->
  <div class="container_dati_generali" *ngIf="tipoPetitumOptions$ | async as tipoPetitumOptions">
    <small id="tipo-petitum-form" class="sr-only">Form petitum</small>
    <form aria-labelledby="tipo-petitum-form" [formGroup]="formGroup" *ngIf="formGroup">
      <fieldset class="form-group">
        <legend>Tipo petitum <em aria-hidden="true" style="color: red;">*</em></legend>
        <div radioButtonInput 
          [radioButtonOptions]="tipoPetitumOptions"
          [nameRadio]="'tipoPetitum'" 
          [submitPending]="submitPending"
          [classCol]="'col-sm-4'"
          [checkedRadioId]="formGroup.get('tipoPetitum').value?.id"
          (onReturn)="formGroup.get('tipoPetitum').setValue($event)" [mandatory]="true"></div>
      </fieldset>
      <div class="row" *ngIf="petitum && petitum.tipoPetitum &&  petitum.tipoPetitum.id ==='QUANTIFICABILE'">
        <div class="col-sm-6">
          <div datePickerInput [labelInput]="'Data inizio calcolo Interessi'"
            [formControlName]="'dataInizioCalcoloInteressi'"
            [control]="formGroup.controls['dataInizioCalcoloInteressi']"
            [submitPending]="formGroup.get('dataInizioCalcoloInteressi').disabled || submitPending" [ngClass]="{'disabled-background': formGroup.controls['dataInizioCalcoloInteressi'].disabled}">
          </div>
        </div>
        <div class="col-sm-6">
          <div textInputCurrency [mandatory]="true" [submitPending]="submitPending" class="{{suggested ? 'component-suggested' : ''}}" [labelInput]="'Importo'"
            formControlName="importoPetitum" [location]="'SezioneEconomica'"
            [control]="formGroup.controls['importoPetitum']" [ngModel]="petitum.importoPetitum" (ngModelChange) = "retrieveImporto($event)">
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
